module.exports = __webpack_public_path__ + "static/img/pete_pictgrid22_1080x818.9c82bcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_pictgrid22_1080x818.jpg
// module id = 6rFD
// module chunks = 0